export default "skymp5-front/8f482106dc532caf285b37b205d3aa1b.png";